// F16 — every store URL and badge asset in the landing suite comes from here.
//
// `play` is null because both Android apps have been in Play review since
// 2026-08-25. Google's brand guidelines expect the badge to link to a real
// listing, so until this is a URL, StoreBadges renders our own "coming soon"
// element instead of Google's artwork. Setting it to the listing URL — and
// dropping the official artwork into PLAY_BADGE — is the only change needed
// the day the app goes live.
export const STORE_LINKS = {
    appStorePos: 'https://apps.apple.com/app/id6799765476',
    appStoreManager: 'https://apps.apple.com/app/id6799765927',
    play: null,
};

// Apple's own artwork, downloaded unmodified from their Marketing Resources
// API. Their toolbox serves no Arabic variant — every ar-* locale code 404s
// and there is no index endpoint — so Arabic falls back to the English badge,
// which Apple's guidelines permit worldwide. Redrawing an Arabic badge
// ourselves would breach the "never redraw the badge" rule, which is the
// more important of the two. If Apple later publishes one, drop it at
// /badges/app-store-ar.svg and point `ar` at it: nothing else changes.
export const APPLE_BADGE = {
    en: '/badges/app-store-en.svg',
    ar: '/badges/app-store-en.svg',
};

// Populated the day the Play listing goes live, alongside STORE_LINKS.play.
export const PLAY_BADGE = {
    en: '/badges/google-play-en.png',
    ar: '/badges/google-play-ar.png',
};

export default STORE_LINKS;
